import { IdentityMigrationStatusResponseStatus } from '@urbanx/agx.support.client';

export const identityMigrationStatusLabels: Record<IdentityMigrationStatusResponseStatus, string> =
  {
    [IdentityMigrationStatusResponseStatus.InProgress]: 'In progress',
    [IdentityMigrationStatusResponseStatus.Complete]: 'Complete',
    [IdentityMigrationStatusResponseStatus.Error]: 'Error',
  };
